import { render, staticRenderFns } from "./ModalCgu.vue?vue&type=template&id=854bbf2a&scoped=true&"
import script from "./ModalCgu.vue?vue&type=script&lang=js&"
export * from "./ModalCgu.vue?vue&type=script&lang=js&"
import style0 from "./ModalCgu.vue?vue&type=style&index=0&id=854bbf2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854bbf2a",
  null
  
)

export default component.exports